import React from 'react';
import { testimonials } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
import { Stars } from '../ui/Stars';
export function TestimonialsGrid() {
  return <section aria-labelledby="testimonios-title" className="w-full bg-ink-800" data-id="element-190" data-mp="3m4i44sehypx0">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-191" data-mp="3m6ksl8004azm">
        <div className="max-w-3xl" data-id="element-192" data-mp="3r2ryj0sedmhk">
          <SectionLabel data-id="element-193" data-mp="3r55vjf6n18rr">Familias que ya acompañan con información</SectionLabel>
          <h2 id="testimonios-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-194" data-mp="2thnktytf1wl4">
            Lo que cuentan padres y madres que ya lo usan
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-195" data-mp="38dd0lf80ddhe">
          {testimonials.map(item => <figure key={item.initials} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6 shadow-panel transition-transform duration-150 ease-out hover:-translate-y-1" data-id="element-196" data-mp="imged492quik">
              <div className="flex items-center gap-3" data-id="element-197" data-mp="kbm9up68mopj">
                <span aria-hidden="true" className="flex h-11 w-11 items-center justify-center rounded-full text-sm font-black text-white" style={{
              backgroundColor: item.color
            }} data-id="element-198" data-mp="ffyhk0wglfft">
                  {item.initials}
                </span>
                <Stars data-id="element-199" data-mp="1fw2snjg724s" />
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] italic leading-relaxed text-body" data-id="element-200" data-mp="3sts578b15uff">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-ink-border pt-4" data-id="element-201" data-mp="3nvi6inq3kbp2">
                <span className="block text-sm font-bold text-white" data-id="element-202" data-mp="3jtwravq3blbp">{item.name}</span>
                <span className="block text-sm text-subtle" data-id="element-203" data-mp="3euk1q37u405f">{item.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}